import moment from "moment";
import { FC } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import { RootState } from "../../store/rootReducer";

const Table = styled.table`
  th, td {
    border: 1px solid #e8e8e8;
  }
  td {
    width: 50px;
    text-align: center;
    cursor: pointer;
  }
  td:hover {
    text-decoration: underline;
  }
`;

export interface IProps {
  setStartDate: (date: string) => void;
  setEndDate: (date: string) => void;
}

const DatePickerTable: FC<IProps> = ({
  setStartDate, setEndDate
}) => {
  const { t } = useTranslation();
  const { serverDate } = useSelector((state: RootState) => state.serverDate);

  const onSetDate = (period: string) => {
    if (!serverDate) return;
    console.log('serverDate', serverDate);

    switch (period) {
      case 'today':
        setStartDate(moment(serverDate).format('YYYYMMDD'));
        break;
      case 'yesterday':
        setStartDate(moment(serverDate).subtract(1, 'days').format('YYYYMMDD'));
        break;
      case '3 days':
        setStartDate(moment(serverDate).subtract(2, 'days').format('YYYYMMDD'));
        break;
      case '7 days':
        setStartDate(moment(serverDate).subtract(6, 'days').format('YYYYMMDD'));
        break;
      case '1 month':
        setStartDate(moment(serverDate).subtract(1, 'months').format('YYYYMMDD'));
        break;
      case '3 months':
        setStartDate(moment(serverDate).subtract(3, 'months').format('YYYYMMDD'));
        break;
      case '6 months':
        setStartDate(moment(serverDate).subtract(6, 'months').format('YYYYMMDD'));
        break;
      case '1 year':
        setStartDate(moment(serverDate).subtract(1, 'years').format('YYYYMMDD'));
        break;
    }

    setEndDate(moment(serverDate).format('YYYYMMDD'));
  }

  return (
    <Table>
      <tbody>
        <tr>
          <td onClick={() => onSetDate('today')}>{t('payment.record.column5')}</td>
          <td onClick={() => onSetDate('yesterday')}>{t('payment.record.column6')}</td>
          <td onClick={() => onSetDate('3 days')}>{t('payment.record.column7')}</td>
          <td onClick={() => onSetDate('7 days')}>{t('payment.record.column8')}</td>
          <td onClick={() => onSetDate('1 month')}>{t('payment.record.column9')}</td>
          <td onClick={() => onSetDate('3 months')}>{t('payment.record.column10')}</td>
          <td onClick={() => onSetDate('6 months')}>{t('payment.record.column11')}</td>
          <td onClick={() => onSetDate('1 year')}>{t('payment.record.column12')}</td>
        </tr>
      </tbody>
    </Table>
  );
}

export default DatePickerTable;
